import { Box, Divider, Typography } from '@mui/material';
import { MentorshipStatusEnum } from '@juno/client-api/model';
import { FilterSideChip } from './FilterSideChip';
import { MAX_FILTERS_LIMIT, MentorshipFilter } from './types';

interface MentorshipStatusFilterProps {
  selectedFilters: MentorshipFilter[];
  appendFilter: (status: MentorshipFilter) => void;
  removeFilter: (status: MentorshipFilter) => void;
  disabled?: boolean;
  totalFiltersApplied: number;
}

export const MENTORSHIP_STATUSES: MentorshipFilter[] = [
  { label: 'Mentor', value: MentorshipStatusEnum.NUMBER_0 },
  { label: 'Mentee', value: MentorshipStatusEnum.NUMBER_1 },
  { label: 'Not Applicable', value: MentorshipStatusEnum.NUMBER_2 },
];

export const MentorshipStatusFilter: React.FC<MentorshipStatusFilterProps> = ({
  selectedFilters,
  appendFilter,
  removeFilter,
  disabled,
  totalFiltersApplied,
}) => {
  const isSelected = (status: MentorshipFilter) =>
    selectedFilters.some((f) => f.value === status.value);

  const isDisabled = disabled || totalFiltersApplied >= MAX_FILTERS_LIMIT;

  const handleFilterClick = (status: MentorshipFilter) => {
    if (isSelected(status)) {
      removeFilter(status);
    } else {
      appendFilter(status);
    }
  };

  return (
    <Box
      sx={{
        my: 1,
        pb: 1,
      }}
    >
      <Typography variant='subtitle1' sx={{ px: 1 }}>
        {selectedFilters.length ? `${selectedFilters.length} ` : ''}
        Mentorship Status
      </Typography>

      <Box p={1}>
        {MENTORSHIP_STATUSES.map((status) => (
          <FilterSideChip
            label={status.label}
            key={status.value}
            disabled={isDisabled && !isSelected(status)}
            isSelected={isSelected(status)}
            onClick={() => handleFilterClick(status)}
          />
        ))}
      </Box>
      <Divider sx={{ mx: 1 }} />
    </Box>
  );
};
